import { Component, OnInit } from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {startWith} from 'rxjs/operators';
import {map} from 'rxjs/operators';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { AreaService } from 'src/app/services/Area/area.service';

export class User {
  constructor(public name: string) { }
}


@Component({
  selector: 'app-select-locationsearch',
  templateUrl: './select-locationsearch.page.html',
  styleUrls: ['./select-locationsearch.page.scss'],
})
export class SelectLocationsearchPage implements OnInit {
		private areaService:AreaService
    constructor(private geolocation:Geolocation,){}
  myControl = new FormControl();

  options = [
    new User('Adelaide'),
    new User('Brisbane'),
    new User('Melbourne'),
    new User('Sydney'),
    new User('Canberra'),
    new User('Queensland'),
    new User('Airlie Beach'),
    new User('Strahan'),
    new User('Swansea'),
    new User('Tathra'),
    new User('Buckland')

  ];

  filteredOptions: Observable<User[]>;

  ngOnInit() {
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith<string | User>(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this.filter(name) : this.options.slice())
      );
  }

  filter(name: string): User[] {
    return this.options.filter(option =>
      option.name.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  displayFn(user?: User): string | undefined {
    return user ? user.name : undefined;
  }

  getloc(){
  	this.geolocation.getCurrentPosition().then((resp) => {
	 // resp.coords.latitude
	 // resp.coords.longitude
	}).catch((error) => {
	  console.log('Error getting location', error);
	});

	let watch = this.geolocation.watchPosition();
	watch.subscribe((data) => {
	 // data can be a set of coordinates, or an error (if an error occurred).
	 // data.coords.latitude
	 // data.coords.longitude
	});
  }
  ionViewDidEnter(){
    this.areaService.showHome=false  
  }
}
